import DOMPurify from 'dompurify';

export const sanitizeTwitchUsername = (username) => {
  if (!username || typeof username !== 'string') return '';
  return username.replace(/[^a-zA-Z0-9_]/g, '').slice(0, 25);
};

export const buildTwitchEmbedUrl = (channel, parent, autoplay = false) => {
  const safeChannel = sanitizeTwitchUsername(channel);
  const safeParent = (parent || '').replace(/[^a-zA-Z0-9.-]/g, '');
  if (!safeChannel || !safeParent) return null;
  return `https://player.twitch.tv/?channel=${safeChannel}&parent=${safeParent}&autoplay=${autoplay ? 'true' : 'false'}`;
};

const ALLOWED_IMAGE_DOMAINS = [
  'static-cdn.jtvnw.net',
  'cdn.supabase.co',
  'blackgamersnetwork.com',
  'vercel.app',
  'ngrok-free.app'
];

export const sanitizeImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') return null;
    const isDomainAllowed = ALLOWED_IMAGE_DOMAINS.some(domain =>
      parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`)
    );
    if (!isDomainAllowed) return null;
    return DOMPurify.sanitize(url);
  } catch {
    return null;
  }
};

export const sanitizeText = (text) => {
  if (!text || typeof text !== 'string') return '';
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
};

export const sanitizeHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });
};

export const safeUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('/')) return url;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
    return DOMPurify.sanitize(url);
  } catch { return null; }
};

export const safeEmail = (email) => {
  if (!email || typeof email !== 'string') return null;
  if (!/^[^\s@"'<>]+@[^\s@"'<>]+\.[^\s@"'<>]+$/.test(email)) return null;
  return email;
};

export const getParentDomain = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return 'localhost';
};
